const testimonials = [
  {
    name: "Sarah K.",
    location: "LSU Campus, Baton Rouge",
    rating: 5,
    text: "I got accepted to study abroad at the London School of Economics and realized I had never had a passport. We had about three weeks before orientation. Fast Passport Center walked me through the acceptance clerk process step by step, reviewed all my documents, and had my passport back in seven business days. I made orientation in London with four days to spare. Every LSU student should know about this service.",
    service: "New Passport",
  },
  {
    name: "James F.",
    location: "ExxonMobil Chemical, Baton Rouge",
    rating: 5,
    text: "I received a last-minute assignment to our plant in Rotterdam with twelve days notice. My passport had been expired for almost two years. Fast Passport Center processed my renewal in five business days. I made my flight from BTR to Atlanta to Amsterdam with no issues. Their document review caught an error in my forms that would have caused a delay I absolutely could not afford.",
    service: "Passport Renewal",
  },
  {
    name: "Karen & Tom M.",
    location: "Zachary, Louisiana",
    rating: 5,
    text: "Our son was invited on a state trade mission to South Korea as part of a Louisiana agricultural export delegation. We had about two and a half weeks and his passport had expired. Fast Passport Center expedited the renewal, communicated clearly about the timeline, and we had the passport back with four days to spare. Outstanding service for a situation that could have been very stressful.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BatonRougeTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Baton Rouge &amp; Capital Region Travelers Say About Our Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Baton Rouge, LSU, and Zachary travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}